module.exports = __webpack_public_path__ + "static/media/Yr-Johannsdottir-Textiles.f8b6d28b.jpg";